const formEditorConstants = {
  INITIALIZE_FORM_EDITOR: 'INITIALIZE_FORM_EDITOR',
  INITIALIZE_FORM_EDITOR_SUCCESS: 'INITIALIZE_FORM_EDITOR_SUCCESS',
  INITIALIZE_FORM_EDITOR_ERROR: 'INITIALIZE_FORM_EDITOR_ERROR',
  FORM_SAVE: 'FORM_SAVE',
  FORM_SAVE_SUCCESS: 'FORM_SAVE_SUCCESS',
  FORM_SAVE_ERROR: 'FORM_SAVE_ERROR',
  FORM_DELETE: 'FORM_DELETE',
  FORM_DELETE_SUCCESS: 'FORM_DELETE_SUCCESS',
  FORM_DELETE_ERROR: 'FORM_DELETE_ERROR',
  FORM_PUBLISH: 'FORM_PUBLISH',
  FORM_PUBLISH_SUCCESS: 'FORM_PUBLISH_SUCCESS',
  FORM_PUBLISH_ERROR: 'FORM_PUBLISH_ERROR',
  FORM_ELEMENT_CHANGE: 'FORM_ELEMENT_CHANGE',
  FORM_ELEMENT_TYPE_CHANGE: 'FORM_ELEMENT_TYPE_CHANGE',
  FORM_EDITOR_MODE_CHANGE: 'FORM_EDITOR_MODE_CHANGE',
  FORM_ELEMENT_SELECTED: 'FORM_ELEMENT_SELECTED',
  FORM_ELEMENT_MOVE_UP: 'FORM_ELEMENT_MOVE_UP',
  FORM_ELEMENT_MOVE_DOWN: 'FORM_ELEMENT_MOVE_DOWN',
  FORM_ELEMENT_REMOVE: 'FORM_ELEMENT_REMOVE',
  FORM_PREVIEW_CHANGE: 'FORM_PREVIEW_CHANGE',
  FORM_DETAILS_CHANGE: 'FORM_DETAILS_CHANGE',
  FORM_DETAILS_ADD_ELEMENT: 'FORM_DETAILS_ADD_ELEMENT',
  FORM_ELEMENT_REQUIRED_CHANGE: 'FORM_ELEMENT_REQUIRED_CHANGE',
  FORM_ELEMENT_OPTIONS_CHANGE: 'FORM_ELEMENT_OPTIONS_CHANGE',
  FORM_UNLOAD: 'FORM_UNLOAD',
  FORM_PRIVACY_CHANGE: 'FORM_PRIVACY_CHANGE',
  FORM_PRIVACY_CHANGE_SUCCESS: 'FORM_PRIVACY_CHANGE_SUCCESS',
  FORM_PRIVACY_CHANGE_ERROR: 'FORM_PRIVACY_CHANGE_ERROR',
  FORM_TASK_ASSIGNEES_CHANGE: 'FORM_TASK_ASSIGNEES_CHANGE',
  FORM_TASK_DEADLINE_CHANGE: 'FORM_TASK_DEADLINE_CHANGE',
  SEARCH_FORM_TASK_ASSIGNEES: 'SEARCH_FORM_TASK_ASSIGNEES',
  FORM_TASK_SUMMARY_CHANGE: 'FORM_TASK_SUMMARY_CHANGE',
  FORM_HEADER_IMAGE_CHANGE: 'FORM_HEADER_IMAGE_CHANGE',
  FORM_CONFIRMATION_TEXT_CHANGE: 'FORM_CONFIRMATION_TEXT_CHANGE',
  FORM_BUTTON_LABEL_CHANGE: 'FORM_BUTTON_LABEL_CHANGE',
  FORM_BUTTON_COLOR_CHANGE: 'FORM_BUTTON_COLOR_CHANGE'
};

export default formEditorConstants;
